<template>
  <div class="walk-score">
    <div class="walk-score__content">
      <div v-if="getEnableWalkScore">
        <SectionHeader>Walk score</SectionHeader>
        <div class="walk-score__frame">
          <HMTWalkScoreFrame />
        </div>
      </div>
      <HMTHoodQ><SectionHeader>HoodQ</SectionHeader></HMTHoodQ>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import SectionHeader from '../../components/SectionHeader';
  import HMTWalkScoreFrame from '@/shared/components/WalkScoreFrame';
  import HMTHoodQ from '@/shared/components/HoodQ';

  export default {
    name: 'WalkScore',
    components: {
      SectionHeader,
      HMTWalkScoreFrame,
      HMTHoodQ
    },
    computed: {
      ...mapGetters('tour', ['getEnableWalkScore'])
    }
  };
</script>

<style lang="scss">
  @import '../../styles/mixins.scss';

  .walk-score {
    background-color: var(--secondary-section-color);
    
    &__content {
      @include layoutContent();
      @include layoutHPadding();
      @include layoutVPadding();
    }

    &__frame {
      width: 100%;
      max-width: 600px;
      margin: 0 auto;

      #ws-walkscore-tile {
        background-color: var(--walkscore-bg-color) !important;
      }
    }
  }
</style>
